module.exports = __webpack_public_path__ + "media/assets/services_manager/logos/faria_one-66d93c9d75c64b4169a650c64306fcb8a0918a7c19947fad37dda9b947a1a996.png";